import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@ngneat/transloco';
import { AuthService } from 'app/core/auth/auth.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'portal-impersonation-banner',
  imports: [MatButtonModule, TranslocoModule],
  host: { class: 'sticky top-0 z-30 print:hidden' },
  template: `@if (auth.isImpersonating) {
    <div
      class="flex flex-wrap items-center justify-between gap-3 border-b border-amber-300 bg-amber-100 px-5 py-3 text-amber-950 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-100"
      role="status">
      <div class="min-w-0">
        <p class="break-words font-semibold">
          {{ 'auth.loginAs.actingAs' | transloco: { email: auth.userEmail } }}
        </p>
        <p class="text-sm">{{ 'auth.loginAs.auditNotice' | transloco }}</p>
      </div>
      <button
        mat-stroked-button
        class="rounded-md"
        [disabled]="exiting()"
        (click)="exit()">
        {{ 'auth.loginAs.exit' | transloco }}
      </button>
    </div>
  }`,
})
export class ImpersonationBannerComponent {
  readonly auth = inject(AuthService);
  readonly exiting = signal(false);
  exit(): void {
    if (this.exiting()) return;
    this.exiting.set(true);
    this.auth
      .endImpersonation()
      .pipe(
        finalize(() => {
          this.auth.signOut();
          window.location.replace('/sign-in');
        })
      )
      .subscribe({ error: () => {} });
  }
}
